/** Identity + auth product events (spec 68 §6.6.3). */
import { z } from 'zod';
import { DEFAULT_SCHEMA_VER, id } from './_shared.js';

export const userEvents = {
  'user.signed_up': {
    schema: z.object({
      user_id: id,
      signup_method: z.enum(['password', 'google', 'email_link', 'invite']),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'user.signed_in': {
    schema: z.object({
      user_id: id,
      method: z.string().min(1),
      account_count: z.number().int().nonnegative().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'user.signed_out': {
    schema: z.object({ user_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  // Pre-identification — no props (§6.6.3).
  'user.password_reset_requested': {
    schema: z.object({}),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'user.password_set': {
    schema: z.object({ user_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'user.email_change_requested': {
    schema: z.object({ user_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'user.totp_enrolled': {
    schema: z.object({ user_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'user.totp_disabled': {
    schema: z.object({ user_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'user.oauth_provider_unlinked': {
    schema: z.object({ user_id: id, provider: z.string().min(1) }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'user.recovery_codes_regenerated': {
    schema: z.object({ user_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'user.session_revoked': {
    schema: z.object({ account_id: id, session_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'user.oauth_grant_revoked': {
    schema: z.object({ account_id: id, client_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'user.signed_out_everywhere': {
    schema: z.object({ user_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'user.notifications_updated': {
    schema: z.object({ user_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
} as const;
